<div [class]="classPrefix('MainPod')">
  <h2>{{params.title | translate}}</h2>
  <wml-options [params]="params.options"></wml-options>
</div>
